import { ApiPost } from '../util/axios'
import { consoleLog } from '../util'

const setOrganizationAdminUserApi = async data => {
  const options = {
    reqId: 'SetOrganizationAdminUser',
    payload: data,
    resId: 'SetOrganizationAdminUserResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const getUserApi = async data => {
  const options = {
    reqId: 'GetUser',
    payload: data,
    resId: 'GetUserResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setUserApi = async data => {
  const options = {
    reqId: 'SetUser',
    payload: data,
    resId: 'SetUserResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

const setUserNonEncryptedPasswordApi = async data => {
  const options = {
    reqId: 'SetUserNonEncryptedPassword',
    payload: data,
    resId: 'SetUserNonEncryptedPasswordResult',
    resType: 'object'
  }
  return await ApiPost(options).then((res) => {
    return res
  },
  (error) => {
    consoleLog('error - ', error)
  })
}

export default {
  setOrganizationAdminUserApi,
  getUserApi,
  setUserApi,
  setUserNonEncryptedPasswordApi
}
